const TEN_MINUTES_IN_MILLIS = 600000;

export function isBrowser() {
  return typeof window !== 'undefined';
}

export function getHasLength({ password = '', length }) {
  return password.length >= length;
}

const number = /[0-9]/;
const symbol = /[-!@$%^&*()_+|~=#`{}[\]:";'<>?,./]/;
const lower = /[a-z]/;
const upper = /[A-Z]/;
const noSpace = /^\S*$/;

export function getHasNumber({ password }) {
  return number.test(password);
}

export function getHasSymbol({ password }) {
  return symbol.test(password);
}

export function getHasLowercase({ password }) {
  return lower.test(password);
}

export function getHasUppercase({ password }) {
  return upper.test(password);
}

export function getHasNoSpaces({ password }) {
  return password.length === 0 ? false : noSpace.test(password);
}

export const getJudgeName = (judgeId, gameState, gameParticipants) => {
  if (judgeId !== '' && judgeId !== undefined && judgeId !== null) {
    for (let i = 0; i < gameParticipants.length; i++) {
      if (gameParticipants[i]["$id"] === judgeId) {
        return gameParticipants[i]["Name"]
      }
      if (gameParticipants[i]["Name"] === judgeId) {
        return gameParticipants[i]["Name"]
      }
    }
  } else if (gameState.JudgeID !== '') {
    for (let i = 0; i < gameParticipants.length; i++) {
      if (gameParticipants[i]["$id"] === gameState.JudgeID) {
        return gameParticipants[i]["Name"]
      }
    }
  } else {
    return ""
  }
}
